import React from 'react'

const CallLogs = (props) => {
    const {item ,showMaximumChat} = props
    return (
        <div>
            <div style={{ padding: "8px" }} className="header-prob">CALL LOGS</div>

            {/* //1 */}
            <table
                style={{
                    border: "1px",
                    solid: "#ccc",
                    borderCollapse: "collapse",
                    width: "98%",
                    marginTop: "12px",
                    backgroundColor : 'white',
                    marginLeft : '8px',
                    borderRadius : '8px'
                }}
            >
                <tr style={{borderRadius : '8px'}} className="table-head">
                    <td style={{width : showMaximumChat ? '30%' : '50%',fontWeight: "700"}} className="call-logs-table">
                        <strong>Type</strong>
                    </td>
                    <td style={{ fontWeight: "400" }} className="call-logs-table">
                        {item?.Call_log_type || 'NA'} 
                    </td>
                </tr>
                <tr className="table-head">
                    <td className="call-logs-table">
                        <strong>Area</strong>
                    </td>
                    <td style={{ fontWeight: "400" }} className="call-logs-table">
                        {item?.call_log_area || 'NA'}
                    </td>
                </tr>
                <tr className="table-head">
                    <td className="call-logs-table">
                        <strong>Sub Area</strong>
                    </td>
                    <td style={{ fontWeight: "400" }} className="call-logs-table">
                        {item?.call_log_sub_area || 'NA'}
                    </td>
                </tr>
                <tr className="table-head">
                    <td className="call-logs-table">
                        <strong>Resolution Code</strong>
                    </td>
                    <td style={{ fontWeight: "400" }} className="call-logs-table">
                        {item?.Call_log_resolution_code || 'NA'}
                    </td>
                </tr>
            </table>
        </div>
    )
}

export default CallLogs
